//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loginMutation from '~/queries/login.graphql';
import canonicalUrls from '~/mixins/canonicalUrls';

export default {
    props: [],
    layout: 'minimal',
    middleware: 'guest',
    mixins: [canonicalUrls],
    data() {
        return {
            error: '',
            form: {
                email: '',
                password: '',
            },
            tagType: 'h2',
        };
    },
    methods: {
        async login() {
            // let token = '';
            // try {
            //     token = await this.$recaptcha.getResponse()
            //     console.log('ReCaptcha token:', token)
            //
            //     // send token to server alongside your form data
            //
            //     // at the end you need to reset recaptcha
            //     await this.$recaptcha.reset()
            //
            // } catch (error) {
            //     console.log('Login error:', error)
            // }
            const variables = this.form;
            try {
                this.error = '';
                if (!this.form.email || !this.form.password) {
                    this.$notify.error(this.$t('account.user.emptycredentials'));
                    throw Error(this.$t('account.user.emptycredentials'));
                }
                const res = await this.$apollo
                    .mutate({
                        mutation: loginMutation,
                        variables,
                        // context: {
                        //     headers: {
                        //         'X-ReCaptcha': token
                        //     }
                        // }
                    })
                    .then(({ data }) => data && data.generateCustomerToken);
                await this.$apolloHelpers.onLogin(res.token);
                let oldCartId = this.$storage.getCookie('cart_id');
                await this.$auth.getUser();
                await this.$store.dispatch('cart/mergeCarts', oldCartId);
                await this.$store.dispatch('wishlist/getWishlist');
                await this.$router.push(this.$store.state.redirect.loginCallBack ?? '/');
            } catch (e) {
                if (e == 'Error: GraphQL error: The account sign-in was incorrect or your account is disabled temporarily. Please wait and try again later.') {
                    this.$notify.error(
                        'Sähköposti ja salasana eivät täsmää, tunnusta ei ole tai tunnuksesi on lukittu. Uusiaksesi salasanan, klikkaa unohditko salasanasi painiketta',
                    );
                } else {
                    this.error = e;
                }
                console.error(e);
            }
        },
    },
    mounted() {
        if (process.client) {
            this.tagType = document.querySelectorAll('h1').length ? 'h2' : 'h1';
        }
    },
    head() {
        return {
            title: this.$t('account.nav.signin'),
            link: this.head.link,
        };
    },
};
